module.exports = " <navbar></navbar> <section class=page-content> <search :placeholder=placeholder choose=表情包></search> <waterfall :imgs=biaos></waterfall> </section> <top></top> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/views/Biao.vue
 ** module id = 77
 ** module chunks = 0
 **/